export default __webpack_public_path__ + "static/4-e1d695e638a817ce9d910a48f90cf964.jpg";